import sortByPath from '~/util/sortByPath';

/**
 * Sorts the options with the filter label
 */
const sortByFilterLabel = sortByPath(['payload', 'filterLabel']);

export default sortByFilterLabel;
